// extracted by mini-css-extract-plugin
module.exports = {"list":"BreadcrumbsNavigation_list___CuSx","item":"BreadcrumbsNavigation_item__T3GmZ","link":"BreadcrumbsNavigation_link__nI3rQ","icon":"BreadcrumbsNavigation_icon__9Ij3Z"};